/* ============================================
   Y.VEST THEME — theme.js
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── CUSTOM CURSOR ───────────────────────
  const cur = document.getElementById('cur');
  const ring = document.getElementById('ring');
  if (cur && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
    (function animCursor() {
      cur.style.left = mx + 'px'; cur.style.top = my + 'px';
      rx += (mx - rx) * 0.1; ry += (my - ry) * 0.1;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(animCursor);
    })();
    document.querySelectorAll('a, button, select, label').forEach(el => {
      el.addEventListener('mouseenter', () => { cur.style.width = '18px'; cur.style.height = '18px'; ring.style.opacity = '0'; });
      el.addEventListener('mouseleave', () => { cur.style.width = '7px'; cur.style.height = '7px'; ring.style.opacity = '.35'; });
    });
  }

  // ── FADE IN ON SCROLL ──────────────────
  const obs = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) setTimeout(() => e.target.classList.add('v'), i * 60);
    });
  }, { threshold: 0.06 });
  document.querySelectorAll('.fi').forEach(el => obs.observe(el));

  // ── PRODUCT GALLERY THUMBNAILS (smooth crossfade, same timing everywhere) ──
  const mainImg = document.getElementById('gallery-main-img');
  if (mainImg) {
    document.querySelectorAll('.gallery-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (thumb.classList.contains('active')) return;
        const newSrc = thumb.dataset.src;
        const newAlt = thumb.dataset.alt || mainImg.alt;

        mainImg.classList.add('is-fading');
        window.setTimeout(() => {
          mainImg.src = newSrc;
          mainImg.alt = newAlt;
          mainImg.classList.remove('is-fading');
        }, 280);

        document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── ACCORDION ──────────────────
  document.querySelectorAll('.acc-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.acc-item');
      const isOpen = item.classList.contains('open');
      // close all
      document.querySelectorAll('.acc-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── VARIANT SWITCHER ────────────────
  const variantInputs = document.querySelectorAll('.variant-option input[type="radio"]');
  const variantIdInput = document.getElementById('variant-id');
  const priceEl = document.getElementById('product-price');
  const atcBtn = document.querySelector('.btn-atc');

  if (variantInputs.length && variantIdInput) {
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        // Build selected options object
        const selected = {};
        document.querySelectorAll('.variant-option input:checked').forEach(inp => {
          selected[inp.name] = inp.value;
        });

        // Find matching variant from Shopify product JSON
        const productData = window.__productData;
        if (!productData) return;

        const match = productData.variants.find(v =>
          v.options.every((opt, i) =>
            opt === selected[`options[${productData.options[i]}]`]
          )
        );

        if (match) {
          variantIdInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (atcBtn) {
            if (match.available) {
              atcBtn.textContent = 'Add to Bag';
              atcBtn.disabled = false;
              atcBtn.classList.remove('btn-atc--sold');
            } else {
              atcBtn.textContent = 'Sold Out';
              atcBtn.disabled = true;
              atcBtn.classList.add('btn-atc--sold');
            }
          }
        }
      });
    });
  }

  // ── MONEY FORMATTER ───────────────
  function formatMoney(cents) {
    return 'CHF ' + (cents / 100).toFixed(2).replace('.', '.');
  }

  // ── ADD TO CART AJAX ──────────────
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const id = document.getElementById('variant-id').value;
      const btn = this.querySelector('.btn-atc');

      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id), quantity: 1 })
        });

        if (res.ok) {
          btn.textContent = 'Added ✓';
          // Update cart count
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const countEl = document.querySelector('.cart-count');
          if (countEl) countEl.textContent = cart.item_count;
          setTimeout(() => { btn.textContent = 'Add to Bag'; }, 2000);
        } else {
          btn.textContent = 'Error — Try Again';
          setTimeout(() => { btn.textContent = 'Add to Bag'; }, 2000);
        }
      } catch (err) {
        btn.textContent = 'Error — Try Again';
        setTimeout(() => { btn.textContent = 'Add to Bag'; }, 2000);
      }
    });
  }

});

  // ── MOBILE MENU ─────────────────
  const burger = document.getElementById('burger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      burger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        burger.classList.remove('open');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }
